module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'media',
		'upload',
		'plupload',
		'plupload',
	],
	config: {
		mode: 		'file',
		secureRoute: '/~/upload/preparedFile',
		pluploaderConfig: {
			filters: {
				mime_types: [
					{title : "Files", extensions : "jpg,jpeg,gif,png,svg,webp,pdf,doc,docx,xls,xlsx,txt,zip"}
				]
			},
		},
	},
}